import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=1ab43737&scoped=true&"
import script from "./Role.vue?vue&type=script&lang=ts&"
export * from "./Role.vue?vue&type=script&lang=ts&"
import style0 from "./Role.vue?vue&type=style&index=0&id=1ab43737&lang=sass&scoped=true&"
import style1 from "./Role.vue?vue&type=style&index=1&id=1ab43737&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab43737",
  null
  
)

export default component.exports